import {genericGetWithParameters, genericDeleteWithParameters, genericCallWithBody} from './Networking';


export async function getBranchesByBankID(bankID, page, items){
    try {
        let params = {
            'BankID': bankID,
            'Page': page,
            'Items': items
        }
        let response = await genericGetWithParameters('Branch/GetBranchesByBankID_forGrid',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}
 
export async function getBranchByID(branchID){
    try {
        let params = {
            'BranchID': branchID
        }
        let response = await genericGetWithParameters('Branch/GetBranchInformationByBranchID',params);
        
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function deleteBranch(id){
    try{
        let params = {
            'BranchID': id
        };
        let response = await genericDeleteWithParameters('Branch/Delete',params);
        return response;
    } catch (error) {
        console.error(error);
    }
}

export async function saveBranch(model){

    try{
        let response = await genericCallWithBody('POST','Branch/SaveBankBranch',model);
        return response;
    } catch (error) {
        console.error(error);
    }
}